module.exports = __webpack_public_path__ + "img/085-solomon-islands.1a16978a.svg";